import z from 'zod';

import { blockSchema, PRICE_CHANGE_TYPE } from 'modules/shaxmatka';

export const newSchema = blockSchema.pick({ floor: true, houseId: true, finishDate: true, name: true, priceCalculateType: true, startDate: true, sale: true });
export const deleteSchema = blockSchema.pick({ id: true });
export const updateSchema = newSchema.merge(deleteSchema);
export const numberingSchema = z.object({ buildingId: z.coerce.number(), byBuilding: z.coerce.boolean() });
export const incrementSchema = z.object({
  buildingId: z.coerce.number(),
  priceChangeType: z.nativeEnum(PRICE_CHANGE_TYPE),
  value: z.coerce.number(),
  increase: z.coerce.boolean()
});
export const basementSchema = z.object({ buildingId: z.number(), countFloors: z.coerce.number(), flatOfFloors: z.coerce.number() });
export const floorSchema = z.object({
  buildingId: z.number(),
  floor: z.coerce.number(),
  before: z.coerce.boolean(),
  countFloors: z.coerce.number(),
  flatOfFloors: z.coerce.number()
});
export const duplicateSchema = z.object({ name: z.string(), fromId: z.number() });

export type NewForm = z.infer<typeof newSchema>;
export type DeleteForm = z.infer<typeof deleteSchema>;
export type UpdateForm = z.infer<typeof updateSchema>;
export type NumberingForm = z.infer<typeof numberingSchema>;
export type IncrementForm = z.infer<typeof incrementSchema>;
export type BasementForm = z.infer<typeof basementSchema>;
export type FloorForm = z.infer<typeof floorSchema>;
export type DuplicateForm = z.infer<typeof duplicateSchema>;
